import request from '@/utils/request'

export default {
  /**
   * 获取台位详情
   */
  getDeskDetail(id) {
    return request.get(`/desks/${id}/detail`)
  },

  /**
   * 获取开台必买列表
   */
  getDeskOpenMustBuyList(deskId) {
    return request.get(`/desks/${deskId}/desk-open-must-buy/list`)
  }
}
